import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateCube = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 72,
	viewBox: "0 0 61 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.4111 35.804L60.778 17.8561L30.5886 0L0.22168 17.8561L30.4111 35.804Z",
			fill: "#ECF2F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.3832 33.8397L57.1013 17.9591L30.5394 2.15967L3.82129 17.9591L30.3832 33.8397Z",
			fill: "#FDFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4619 33.8397V2.15967L57.1019 17.9997L30.4619 33.8397Z",
			fill: "url(#paint0_linear_170_9014)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4619 33.8397V2.15967L3.8219 17.9997L30.4619 33.8397Z",
			fill: "url(#paint1_linear_170_9014)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.22168 17.856V53.8157L30.5886 72V35.8039L0.22168 17.856Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.7783 17.856V53.8157L30.4114 72V35.8039L60.7783 17.856Z",
			fill: "#6B6F76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4532 33.8335L13.5869 23.8091V25.7809L30.4532 35.7481L45.7674 26.7191V24.7409L30.4532 33.8335Z",
			fill: "#ECF2F9"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_170_9014",
			x1: 43.7819,
			y1: 2.15967,
			x2: 43.7819,
			y2: 33.8397,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#454955" }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_170_9014",
			x1: 17.1419,
			y1: 2.15967,
			x2: 17.1419,
			y2: 33.8397,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#454955" }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
		})] })
	]
});
export default SvgEmptyStateCube;
